import { CurrentCoding } from "@/stores/types";

export function isProductAssembly(item: CurrentCoding): boolean {
  return item && !item.Parent;
}

export function isProductSelected(item: CurrentCoding): boolean {
  return !!item.Criterias.length;
}

export function isCodingLabel(item: CurrentCoding): boolean {
  return item.CodeTypeId === "LABEL";
}

export function isCodingCertificate(item: CurrentCoding): boolean {
  return item && item.Category === "Certificates";
}
